import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=47fba3f0&scoped=true&"
var script = {}
import style0 from "./Notifications.vue?vue&type=style&index=0&id=47fba3f0&lang=scss&scoped=true&"
import style1 from "./Notifications.vue?vue&type=style&index=1&id=47fba3f0&lang=scss&scoped=true&"
import style2 from "./Notifications.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fba3f0",
  null
  
)

export default component.exports